import type { ResultsReadSource } from '@breakoutlearning/firebase-repository/cubits/resultsReadSource'
import { useBreakoutUser } from 'hooks/profile'
import { observer } from 'mobx-react-lite'
import { useCallback } from 'react'
import {
  getResultsReadSource,
  nextResultsReadSource,
  setResultsReadSource,
} from 'util/resultsReadSource'

// CX-only control that overrides, for this browser tab, where the class
// Participants tab and the assignment Gradebook tab read from. Each click moves
// to the next state and reloads, because the repository reads the override
// once at build. Sits just right of SlideDeckSourceToggle on the bottom edge so
// the two never overlap.
export const ResultsReadSourceToggle = observer(
  function ResultsReadSourceToggle() {
    const { isCorre } = useBreakoutUser()
    const source = getResultsReadSource()

    const onToggle = useCallback(() => {
      setResultsReadSource(nextResultsReadSource(source))
      window.location.reload()
    }, [source])

    if (!isCorre) return null

    // QA/CX label; not worth an i18n key.
    const label = `Results source: ${sourceLabel(source)}`

    return (
      <button
        type="button"
        onClick={onToggle}
        data-testid="results-read-source-toggle"
        className="fixed bottom-0 left-1/2 z-60 ml-32 rounded-t-lg border border-b-0 border-black/10 bg-white px-3 py-1 text-xs font-medium text-black shadow-lg hover:bg-gray-50"
      >
        {label}
      </button>
    )
  }
)

function sourceLabel(source: ResultsReadSource | undefined) {
  if (source === 'api') return 'API'
  if (source === 'firestore') return 'Firestore'
  return 'default (flag)'
}
